import Vue from 'vue';
import {createInertiaApp, router} from '@inertiajs/vue2';
import Echo from 'laravel-echo';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import {ZiggyVue} from 'ziggy';
import Layout from './Layouts/Default.vue';
import Formatters from './Mixins/Formatters';
import GlobalTimer from './Plugins/GlobalTimer';

window.Pusher = require('pusher-js');

window.onbeforeunload = () => {
  // reset scroll after hard refresh
  if (window.location.search.includes('page=')) {
    window.scrollTo(0, 0);
  }
};

createInertiaApp({
  resolve: (name) => {
    const page = require(`./Pages/${name}`);
    if (page.default.layout === undefined) {
      page.default.layout = Layout;
    }
    return page;
  },
  setup ({el, App, props, plugin}) {
    Vue.use(plugin);
    Vue.use(ZiggyVue);
    Vue.mixin(Formatters);

    const bugsnagConfig = props.props.initialPage.props.bugsnag;
    if (bugsnagConfig.enabled) {
      Bugsnag.start({
        apiKey: bugsnagConfig.api_key,
        // appVersion: bugsnagConfig.app_version,
        // releaseStage: bugsnagConfig.release_stage,
        plugins: [new BugsnagPluginVue()],
        onError: function (event) {
          if (bugsnagConfig.metadata) {
            for (let key in bugsnagConfig.metadata) {
              event.addMetadata(key, bugsnagConfig.metadata[key]);
            }
          }
        },
      });

      Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);
    }

    Vue.prototype.$eventHub = new Vue(); // Global event bus

    // Laravel Echo
    const pusherConfig = props.props.initialPage.props.pusher;
    Vue.prototype.$echo = new Echo({
      broadcaster: 'pusher',
      key: pusherConfig.key,
      cluster: pusherConfig.cluster,
      forceTLS: true,
    });

    Vue.prototype.$echo.channel('website')
        .listen('RefreshAllViewers', () => window.location.reload());

    new Vue({render: h => h(App, props)})
        .$mount(el);

    let globalTimer = new GlobalTimer();
    router.on('navigate', () => globalTimer.restart());
    router.on('finish', () => globalTimer.restart());
  },
  progress: {
    color: '#fff',
  },
});

